import TrackingAction from '../../tracking-manager'
import getFeatureAppId from './tracking-utils/getFeatureAppId'
import getPageId from './tracking-utils/getPageId'
import getPageName from './tracking-utils/getPageName'
import getTemplateType from './tracking-utils/getTemplateType'
import FilterList from './tracking-utils/interfaces/FilterList'
import PriceCampaignDescription from './tracking-utils/interfaces/PriceCampaignDescription'
import {store} from '../../app/store'
import {UserDataForm} from '../../types/userData'
import {getFormName} from './tracking-utils/getFormName'
import SingleModelInterface from '../../types/singleModelInterface'
import {joinParts} from './tracking-utils/joinParts'

export enum TRACKING {
    PAGE_CATEGORY = 'promozioni',
    APPLICATION_ID = 'VWLocalPromozioniD6',
    FEATURE_APP_VARIANT_SHOWROOM = 'PromozioniShowroom-D6-IT',
    FEATURE_APP_VARIANT_STANDALONE = 'Promozioni-Standalone-D6-IT ',
    FEATURE_APP_ID_VERSION = '1.0.0',
    LINK_NAME_SMALL_BANNER_CLICK = 'model',
    LINK_NAME_BIG_BANNER_CLICK = 'Scopri tutte le promozioni',
    FORM_TYPE = 'quote',
    STEP_NAME = 'Thank you page',
    STEP_NUMBER = '2',
    LEAD_ID = 'IT-SFACPN-',
    FORM_NAME = 'Preventivo promozioni',
    FORM_NAME_OVERVIEW = 'Overview',
    FORM_NAME_MODEL = 'Model',
    FORM_NAME_SHOWROOM = 'Showroom',
    FORM_NAME_AUTO = 'Auto',
    FORM_SUBMISSION_SUCCESS = 'Form submission success',
    FORM_SUBMISSION_ERROR = 'Form submission error',
    FORM_SELECTED_MODEL = 'Modello selezionato',
    FORM_LAYER_OPEN = 'Form layer open',
    FORM_LAYER_CLOSE = 'Form layer close',
}

const pageId = getPageId()

export function getAccordionOpenClickData(
    modelName: string,
    modelSlug: string,
    selectedPromotionTitle: string,
    selectedPromotionMotorization: string,
    trackingBrand: string,
    isShowroom: boolean
): Record<string, unknown> {
    const pageName = getPageName(modelSlug)

    return {
        eventInfo: {
            eventAction:
                TrackingAction.VWBasic_VehiclePromotionsAccordionOpen_Click,
            pageName,
            contentId: joinParts(
                selectedPromotionTitle,
                selectedPromotionMotorization
            ),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            placeholder: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName,
            CarlineName: modelName,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            Equipmentline: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: undefined,
            PriceCampaignValue: undefined,
        },
        link: {
            name: selectedPromotionTitle,
            url: 'Accordion open',
        },
    }
}

export function getAccordionCloseClickData(
    modelName: string,
    modelSlug: string,
    selectedPromotionTitle: string,
    selectedPromotionMotorization: string,
    trackingBrand: string,
    isShowroom: boolean
): Record<string, unknown> {
    const pageName = getPageName(modelSlug)

    return {
        eventInfo: {
            eventAction:
                TrackingAction.VWBasic_VehiclePromotionsAccordionClose_Click,
            pageName,
            contentId: joinParts(
                selectedPromotionTitle,
                selectedPromotionMotorization
            ),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            placeholder: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName,
            CarlineName: modelName,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            Equipmentline: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: undefined,
            PriceCampaignValue: undefined,
        },
        link: {
            name: selectedPromotionTitle,
            url: 'Accordion close',
        },
    }
}

export function getVehiclePromotionsLinkClickData(
    linkText: string,
    selectedPromotionTitle: string,
    modelName: string,
    modelSlug: string,
    trackingBrand: string,
    isShowroom: boolean
): Record<string, unknown> {
    return {
        eventInfo: {
            eventAction: TrackingAction.VWBasic_VehiclePromotionsLink_Click,
            pageId,
            pageName: getPageName(modelSlug),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        content: {
            Type: undefined,
            Name: undefined,
            ItemCount: undefined,
            ItemPosition: undefined,
            Asset: undefined,
        },
        personalization: {
            status: false,
            moduleId: undefined,
            personalizable: false,
            placeholderId: undefined,
            placeholder: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            EquipmentlineName: undefined,
            CarlineId: modelName,
            CarlineName: modelName,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: [selectedPromotionTitle],
            PriceCampaignValue: undefined,
        },
        link: {
            url: getPageId(),
            name: linkText,
        },
    }
}

export function getVehiclePromotionsButtonClickData(
    linkText: string,
    modelName: string,
    modelSlug: string,
    trackingBrand: string,
    isShowroom: boolean,
    priceCampaignDescription?: string
): Record<string, unknown> {
    return {
        eventInfo: {
            eventAction: TrackingAction.VWBasic_VehiclePromotionsButton_Click,
            pageId,
            pageName: getPageName(modelSlug),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        content: {
            Type: undefined,
            Name: undefined,
            ItemCount: undefined,
            ItemPosition: undefined,
            Asset: undefined,
        },
        personalization: {
            status: false,
            moduleId: undefined,
            personalizable: undefined,
            placeholderId: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName,
            CarlineName: modelName,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            EquipmentlineName: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: [priceCampaignDescription ?? linkText],
            PriceCampaignValue: undefined,
        },
        link: {
            url: window.location.href
                .replace('https://', '')
                .replace('http://', ''),
            name: linkText,
        },
    }
}

export function getFilterSearchResultPageloadData(
    numberOfResults: number,
    trackingBrand: string,
    isShowroom: boolean
): Record<string, unknown> {
    return {
        eventInfo: {
            eventAction: TrackingAction.VWBasic_FilterSearchResult_Pageload,
            pageId,
            pageName: getPageName('', false),
            contentId: undefined,
            pageCategory: TRACKING.PAGE_CATEGORY,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        personalization: {
            status: false,
            moduleId: undefined,
            personalizable: undefined,
            placeholderId: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
            aemResourcePath: undefined,
        },
        filter: {
            numberOfResults,
            filterlist: [
                {
                    type: 'multi_value',
                    name: 'CA',
                    values: undefined,
                },
                {
                    type: 'multi_value',
                    name: 'FT',
                    values: undefined,
                },
            ],
            sortOrder: undefined,
        },
    }
}

export function getVWBasicFilterSelectClickData(
    contentId: string,
    filterName: string,
    filterValues: string[],
    trackingBrand: string,
    isShowroom: boolean
): Record<string, unknown> {
    return {
        eventInfo: {
            eventAction: TrackingAction.VWBasic_FilterSelect_Click,
            pageId,
            pageName: getPageName('', false),
            contentId,
            pageCategory: TRACKING.PAGE_CATEGORY,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
            sectionName: undefined,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
            commerce: undefined,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            moduleId: undefined,
            personalizable: undefined,
            placeholderId: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        filter: {
            type: 'multi_value',
            name: filterName,
            values: filterValues,
            lowerbound: undefined,
            upperbound: undefined,
        },
    }
}

export function getVehicleFilterSearchResultLoadData(
    numberOfResults: number,
    filterlist: FilterList[],
    trackingBrand: string,
    isShowroom: boolean
): Record<string, unknown> {
    return {
        eventInfo: {
            eventAction: TrackingAction.VWBasic_FilterSearchResult_Load,
            pageId,
            pageName: getPageName('', false),
            contentId: undefined,
            pageCategory: TRACKING.PAGE_CATEGORY,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            moduleId: undefined,
            personalizable: undefined,
            placeholderId: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            BodyTypeName: undefined,
            CarlineId: undefined,
            CarlineName: undefined,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            EquipmentlineName: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceType: undefined,
            PriceTypeParameter: undefined,
            PriceRateCurrency: undefined,
            PriceRateType: undefined,
            PriceRateBasic: undefined,
            PriceRateAdditional: undefined,
            PriceRateTotal: undefined,
            PriceTotalCurrency: undefined,
            PriceTotalBasic: undefined,
            PriceTotalAdditional: undefined,
            PriceTotalTotal: undefined,
        },
        filter: {
            numberOfResults,
            filterlist,
            sortOrder: undefined,
        },
    }
}

export function getVehiclePromotionsSelectClickData(
    modelName: string,
    priceCampaignDescription: PriceCampaignDescription,
    trackingBrand: string,
    isShowroom: boolean
): Record<string, unknown> {
    return {
        eventInfo: {
            eventAction: TrackingAction.VWBasic_VehiclePromotionsSelect_Click,
            pageId: getPageId(),
            pageName: getPageName('', false),
            contentId: undefined,
            contentLabels: undefined,
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            moduleId: undefined,
            personalizable: undefined,
            placeholderId: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName,
            CarlineName: modelName,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            EquipmentlineName: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: [priceCampaignDescription.title],
            PriceCampaignValue: undefined,
        },
        link: {
            url: getPageId(),
            name: `Scopri tutte le promozioni ${modelName}`,
        },
    }
}

export function getVehiclePromotionsPageloadData(
    modelName: string,
    priceCampaignDescription: PriceCampaignDescription,
    trackingBrand: string,
    isShowroom: boolean
): Record<string, unknown> {
    return {
        eventInfo: {
            eventAction: TrackingAction.VWBasic_GenericFeatureApp_Load,
            pageId: getPageId(),
            pageName: getPageName(modelName),
            contentId: undefined,
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            moduleId: undefined,
            personalizable: undefined,
            placeholderId: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName,
            CarlineName: modelName,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            EquipmentlineName: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: [priceCampaignDescription.title],
            PriceCampaignValue: undefined,
        },
    }
}

export function getFilterResetClickData(
    linkName: string,
    numberOfResults: number,
    trackingBrand: string,
    filterlist: FilterList[],
    isShowroom: boolean
): Record<string, unknown> {
    return {
        eventInfo: {
            eventAction: TrackingAction.VWBasic_FilterReset_Click,
            pageId: getPageId(),
            pageName: getPageName('', false),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
            commerce: undefined,
        },
        personalization: {
            status: false,
            moduleId: undefined,
            personalizable: undefined,
            placeholderId: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            BodyTypeName: undefined,
            CarlineId: undefined,
            CarlineName: undefined,
            CarlineIsRecommendation: undefined,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            SalesgroupIsRecommendation: undefined,
            EquipmentlineName: undefined,
            EquipmentlineIsRecommendation: undefined,
            ModelId: undefined,
            ModelTrimFeatures: undefined,
            ModelName: undefined,
            ModelYear: undefined,
            ModelModelVersion: undefined,
            ModelIsRecommendation: undefined,
            ModelDriveType: undefined,
            ModelGearType: undefined,
            EnginePowerHPKW: undefined,
            EngineFuelTypePrimary: undefined,
            EngineFuelTypeNonPrimary: undefined,
            EmissionCo2CombinedPrimary: undefined,
            ConsumptionCombinedPrimary: undefined,
            ConsumptionCombinedNonPrimary: undefined,
            EmissionConsumptionEfficiencyClass: undefined,
            EmissionConsumptionTestingMethod: undefined,
            ExteriorColorCode: undefined,
            ExteriorColorName: undefined,
            ExteriorColorIsRecommendation: undefined,
            InteriorColorCode: undefined,
            InteriorColorName: undefined,
            InteriorColorIsRecommendation: undefined,
            WheelsBasicId: undefined,
            WheelsBasicName: undefined,
            WheelsBasicIsRecommendation: undefined,
            PriceCurrency: undefined,
            PriceBasis: undefined,
            PriceExterior: undefined,
            PriceOptions: undefined,
            PriceTotalConfiguration: undefined,
            PriceRecommendedOptions: undefined,
            PriceType: undefined,
            PriceCustomerType: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: undefined,
            PriceCampaignValue: undefined,
            OptionsNumber: undefined,
            OptionsList: undefined,
        },
        process: {
            StepName: undefined,
        },
        link: {
            url: undefined,
            name: linkName,
        },
        filter: {
            type: 'complex',
            name: 'Reset filters',
            results: undefined,
            numberOfResults,
            values: undefined,
            filterlist,
        },
    }
}

export function getFormSubmissionSuccessMessageLoadData(
    modelName: string | undefined,
    modelSlug: string | undefined,
    trackingBrand: string,
    isShowroom: boolean,
    userData: UserDataForm,
    responseDataId: number,
    isSingle: boolean,
    selectedPromotionTitle: string,
    selectedPromotionMotorization: string,
    cycleID: string
): Record<string, unknown> {
    const pageName =
        isSingle && modelSlug ? getPageName(modelSlug) : getPageName('', false)
    const formName = getFormName(isShowroom, !isSingle)

    return {
        eventInfo: {
            eventAction:
                TrackingAction.VWBASIC_FORM_SUBMISSION_SUCCESS_MESSAGE_LOAD,
            pageId,
            pageName,
            contentId: joinParts(
                formName,
                selectedPromotionTitle,
                selectedPromotionMotorization
            ),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            placeholder: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName ? modelName : undefined,
            CarlineName: modelName ? modelName : undefined,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            Equipmentline: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: selectedPromotionTitle
                ? [selectedPromotionTitle]
                : undefined,
            PriceCampaignValue: undefined,
        },
        link: {
            url: getPageId(),
            name: TRACKING.FORM_SUBMISSION_SUCCESS,
        },
        form: {
            FormType: TRACKING.FORM_TYPE,
            FormName: formName,
            MarketingConsent: [
                {
                    marketing: userData.marketing_consent,
                    profilazione: userData.profiling_consent,
                    servizio: userData.privacy_consent,
                },
            ],
            FormStart: false,
            LeadID: TRACKING.LEAD_ID + responseDataId,
            CycleID: cycleID,
        },
        process: {
            StepName: TRACKING.STEP_NAME,
            StepNumber: TRACKING.STEP_NUMBER,
        },
    }
}

export function getFormErrorMessageLoadData(
    modelName: string | undefined,
    modelSlug: string | undefined,
    trackingBrand: string,
    isShowroom: boolean,
    isSingle: boolean,
    ErrorFormFields: string[],
    selectedPromotionTitle: string,
    selectedPromotionMotorization: string,
    cycleID: string
): Record<string, unknown> {
    const pageName =
        isSingle && modelSlug ? getPageName(modelSlug) : getPageName('', false)
    const formName = getFormName(isShowroom, !isSingle)

    return {
        eventInfo: {
            eventAction: TrackingAction.VWBASIC_FORM_ERROR_MESSAGE_LOAD,
            pageId,
            pageName,
            contentId: joinParts(
                formName,
                selectedPromotionTitle,
                selectedPromotionMotorization
            ),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            placeholder: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName ? modelName : undefined,
            CarlineName: modelName ? modelName : undefined,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            Equipmentline: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: selectedPromotionTitle
                ? [selectedPromotionTitle]
                : undefined,
            PriceCampaignValue: undefined,
        },
        link: {
            url: getPageId(),
            name: TRACKING.FORM_SUBMISSION_ERROR,
        },
        form: {
            FormType: TRACKING.FORM_TYPE,
            FormName: formName,
            ErrorFormFields,
            CycleID: cycleID,
        },
    }
}

export function getFormBasicClickData(
    modelName: string | undefined,
    modelSlug: string | undefined,
    trackingBrand: string,
    isShowroom: boolean,
    isSingle: boolean,
    selectedPromotionTitle: string,
    selectedPromotionMotorization: string
): Record<string, unknown> {
    const pageName =
        isSingle && modelSlug ? getPageName(modelSlug) : getPageName('', false)
    const formName = getFormName(isShowroom, !isSingle)

    return {
        eventInfo: {
            eventAction: TrackingAction.VWBASIC_FORM_CTA_CLICK,
            pageId,
            pageName,
            contentId: joinParts(
                formName,
                selectedPromotionTitle,
                selectedPromotionMotorization
            ),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            placeholder: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName ? modelName : undefined,
            CarlineName: modelName ? modelName : undefined,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            Equipmentline: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: selectedPromotionTitle
                ? [selectedPromotionTitle]
                : undefined,
            PriceCampaignValue: undefined,
        },
        link: {
            url: getPageId(),
            name: TRACKING.FORM_SUBMISSION_ERROR,
        },
        form: {
            FormType: TRACKING.FORM_TYPE,
            FormName: formName,
        },
    }
}

export function getBasicButtonClickData(
    modelName: string | undefined,
    modelSlug: string | undefined,
    trackingBrand: string,
    isShowroom: boolean,
    isSingle: boolean,
    selectedPromotionTitle: string,
    selectedPromotionMotorization: string,
    linkName: string
): Record<string, unknown> {
    const pageName =
        isSingle && modelSlug ? getPageName(modelSlug) : getPageName('', false)
    const formName = getFormName(isShowroom, !isSingle)

    return {
        eventInfo: {
            eventAction: TrackingAction.VWBasic_Button_Click,
            pageId,
            pageName,
            contentId: joinParts(
                formName,
                selectedPromotionTitle,
                selectedPromotionMotorization
            ),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            placeholder: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName ? modelName : undefined,
            CarlineName: modelName ? modelName : undefined,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            Equipmentline: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: selectedPromotionTitle
                ? [selectedPromotionTitle]
                : undefined,
            PriceCampaignValue: undefined,
        },
        link: {
            url: getPageId(),
            name: linkName,
            newTab: false,
        },
        form: {
            FormType: TRACKING.FORM_TYPE,
            FormName: formName,
        },
    }
}

export function getFormSelectedModelData(
    selectedModel: SingleModelInterface,
    trackingBrand: string,
    isShowroom: boolean,
    selectedPromotionTitle: string,
    selectedPromotionMotorization: string
): Record<string, unknown> {
    const pageName = getPageName('', false)
    const formName = getFormName(isShowroom, true)

    return {
        eventInfo: {
            eventAction: TrackingAction.VWBASIC_FORM_CTA_CLICK,
            pageId,
            pageName,
            contentId: joinParts(
                formName,
                selectedPromotionTitle,
                selectedPromotionMotorization
            ),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            placeholder: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: selectedModel.carline_name,
            CarlineName: selectedModel.carline_name,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            Equipmentline: undefined,
            ModelId: undefined,
            ModelName: selectedModel.name,
            PriceCampaignID: undefined,
            PriceCampaignDescription: selectedPromotionTitle
                ? [selectedPromotionTitle]
                : undefined,
            PriceCampaignValue: undefined,
        },
        link: {
            url: getPageId(),
            name: TRACKING.FORM_SELECTED_MODEL,
        },
        form: {
            FormType: TRACKING.FORM_TYPE,
            FormName: formName,
        },
    }
}

export function getFormLayerLoadData(
    modelName: string | undefined,
    modelSlug: string | undefined,
    trackingBrand: string,
    isShowroom: boolean,
    isSingle: boolean,
    selectedPromotionTitle: string,
    selectedPromotionMotorization: string,
    cycleID: string
): Record<string, unknown> {
    const pageName =
        isSingle && modelSlug ? getPageName(modelSlug) : getPageName('', false)
    const formName = getFormName(isShowroom, !isSingle)

    return {
        eventInfo: {
            eventAction: TrackingAction.VWBASIC_FORM_LAYER_LOAD,
            pageId,
            pageName,
            contentId: joinParts(
                formName,
                selectedPromotionTitle,
                selectedPromotionMotorization
            ),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            placeholder: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName ? modelName : undefined,
            CarlineName: modelName ? modelName : undefined,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            Equipmentline: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: selectedPromotionTitle
                ? [selectedPromotionTitle]
                : undefined,
            PriceCampaignValue: undefined,
        },
        link: {
            url: getPageId(),
            name: TRACKING.FORM_LAYER_OPEN,
        },
        form: {
            FormType: TRACKING.FORM_TYPE,
            FormName: formName,
            FormStart: true,
            CycleID: cycleID,
        },
        process: {
            Name: TRACKING.FORM_NAME,
            StepName: TRACKING.FORM_NAME,
        },
    }
}

export function getFormLayerCloseData(
    modelName: string | undefined,
    modelSlug: string | undefined,
    trackingBrand: string,
    isShowroom: boolean,
    isSingle: boolean,
    selectedPromotionTitle: string,
    selectedPromotionMotorization: string
): Record<string, unknown> {
    const pageName =
        isSingle && modelSlug ? getPageName(modelSlug) : getPageName('', false)
    const formName = getFormName(isShowroom, !isSingle)

    return {
        eventInfo: {
            eventAction: TrackingAction.VWBASIC_FORM_LAYER_CLOSE_CLICK,
            pageId,
            pageName,
            contentId: joinParts(
                formName,
                selectedPromotionTitle,
                selectedPromotionMotorization
            ),
            pageCategory: TRACKING.PAGE_CATEGORY,
            sectionName: undefined,
            templateType: getTemplateType(isShowroom),
            brand: trackingBrand,
        },
        environment: {
            featureAppId: getFeatureAppId(isShowroom),
            featureAppIdAppVersion: TRACKING.FEATURE_APP_ID_VERSION,
            featureAppVariant: isShowroom
                ? TRACKING.FEATURE_APP_VARIANT_SHOWROOM
                : TRACKING.FEATURE_APP_VARIANT_STANDALONE,
        },
        user: {
            loginStatus: store.getState().general.logged,
        },
        personalization: {
            status: false,
            placeholder: undefined,
            contentId: undefined,
            activityId: undefined,
            activityName: undefined,
            experienceId: undefined,
            experienceName: undefined,
            offerId: undefined,
            offerName: undefined,
        },
        configuration: {
            CarlineId: modelName ? modelName : undefined,
            CarlineName: modelName ? modelName : undefined,
            SalesgroupId: undefined,
            SalesgroupName: undefined,
            Equipmentline: undefined,
            ModelId: undefined,
            ModelName: undefined,
            PriceCampaignID: undefined,
            PriceCampaignDescription: selectedPromotionTitle
                ? [selectedPromotionTitle]
                : undefined,
            PriceCampaignValue: undefined,
        },
        link: {
            url: getPageId(),
            name: TRACKING.FORM_LAYER_CLOSE,
        },
        form: {
            FormType: TRACKING.FORM_TYPE,
            FormName: formName,
            FormStart: false,
        },
        process: {
            StepName: TRACKING.FORM_NAME,
            StepNumber: TRACKING.FORM_NAME,
        },
    }
}
